export { default as ApplyDetail } from "./Details";
export { default as ApplyGrid } from "./Grid";